<template>
  <sb-pagination
    key="ts"
    v-bind="pagination"
    data-sb-regression="sb-legacy-paginator"
  >
    <template #pagination-links>
      <sb-pagination-links :range="pagination.range">
        <template
          v-if="!pagination.hidePrevious"
          #page-link-previous
        >
          <sb-pagination-link>
            <sb-text value="sbTable.previous" />
          </sb-pagination-link>
        </template>
        <template
          v-if="!pagination.hideLinks"
          #page-links="{ page }"
        >
          <sb-pagination-link>
            {{ page }}
          </sb-pagination-link>
        </template>
        <template
          v-if="!pagination.hideNext"
          #page-link-next
        >
          <sb-pagination-link>
            <sb-text value="sbTable.next" />
          </sb-pagination-link>
        </template>
      </sb-pagination-links>
    </template>
    <template
      v-if="!pagination.hideText"
      #pagination-text="{ totalPages, totalRecords }"
    >
      <sb-pagination-text>
        <sb-text
          value="sbPagination.pagination"
          :params="{ currentPage: pagination.currentPage, totalPages, visibleRecordsInterval, totalRecords}"
        />
      </sb-pagination-text>
    </template>
    <template
      v-if="!pagination.hideInput"
      #pagination-input
    >
      <sb-pagination-input
        version="next"
        label-text="Go to page: "
      />
    </template>
  </sb-pagination>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import SbPagination from '@src/components/Pagination/SbPagination.vue';
import SbPaginationLinks from '@src/components/Pagination/components/SbPaginationLinks.vue';
import SbPaginationLink from '@src/components/Pagination/SbPaginationLink.vue';
import SbPaginationText from '@src/components/Pagination/SbPaginationText.vue';
import SbPaginationInput from '@src/components/Pagination/components/SbPaginationInput.vue';
import SbText from '@src/components/Text/SbText.vue';

const props = defineProps({
  /**
   * Pagination object with default values
   *  range: 3,
   *  pageSize: 10,
   *  currentPage: 1,
   *  totalPages: 2,
   *  totalRecords: 0,
   *  visibleRecords: 0,
   *  hidePrevious: false,
   *  hideLinks: false,
   *  hideNext: false,
   *  hideText: false,
   *  hideInput: false,
   */
  pagination: {
    type: Object,
    default: () => ({
      pageSize: 10,
      range: 3,
      currentPage: 1,
      totalPages: 1,
      totalRecords: 0,
      visibleRecords: 0,
      hidePrevious: false,
      hideLinks: false,
      hideNext: false,
      hideText: false,
      hideInput: false,
    }),
  },
});

const visibleRecordsInterval = computed(() => {
  // calculate min item based on current page
  let startItem = ((props.pagination.currentPage - 1) * props.pagination.pageSize) + 1;
  // calculate last item based on current page
  let endItem = props.pagination.currentPage * props.pagination.pageSize;

  // update last item count based on total records
  if (endItem > props.pagination.totalRecords) {
    endItem = props.pagination.totalRecords;
  }

  // edge case when there is no data
  if (startItem > endItem) {
    startItem = 0;
  }

  return `${startItem} - ${endItem}`;
});
</script>
